<div class="container-fluid interview-summary">
  <div class="row">
    <div class="content-panel col-md-12 col-sm-12 col-12">
      <div class="row pb-5">
        <div class="col">
          <h2 class="underline">{{ messages.getText('WILL.interview.title') }}</h2> <!-- aria -->
        </div>
      </div>
      <div class="row">
        <div class="col-12 interview-finished">
          <h3 class="stageTitle pb-3" id="interview-summary-header" tabindex="-1">{{ messages.getText('WILL.interview.summary.title') }}</h3>
          <div class="topic-form">
            <div class="info pb-10" [innerHTML]="messages.getText('WILL.interview.summary.description')"></div>
            @if (summary?.topics) {
              <dl class="accordion">
                @for (topicEntry of summary!.topics! | keyvalue:sortByOrder; track topicEntry.value.id) {
                  @let topicActive = isTopicActive(topicEntry.value.id!);
                  <dt [class.active]="topicActive">
                    <button class="btn topic-drawer w-100" tabindex="0"
                            [attr.aria-controls]="topicEntry.value.id"
                            (click)="toggleTopic(topicEntry.value)">
                      <img class="mx-2" [class.active]="topicActive" alt="Dropdown arrow">
                      {{ messages.getText(type + ".topic." + topicEntry.value.id!) }}
                      @if (DEBUG) { <span class="badge bg-secondary">{{ topicEntry.value.id }}</span> }
                    </button>
                  </dt>
                  <dd [class.active]="topicActive" [class.collapsed]="!topicActive">
                    <div class="content">
                      @if (topicEntry.value.questions.length) {
                        <summary-questions class="row"
                                           [type]="type"
                                           [topic]="topicEntry.value"
                                           [interviewId]="this.interviewId"
                                           [questions]="topicEntry.value.questions"
                                           [interviewId]="interviewId"
                                           [summary]="this"
                                           [active]="isTopicActive(topicEntry.value.id!)"
                                           [loading]="loading" />
                      }
                    </div>
                  </dd>
                }
              </dl>
            }
          </div>
        </div>
      </div>
      <div class="summary-buttons position-relative row mt-4">
        <div class="col-12">
          <button class="btn primary rounded-pill submit" id="prev"
                  type="button" (click)="completeInterview()" (keyup.enter)="completeInterview()">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.complete-interview', 'Complete interview') }}
          </button>
        </div>
        <div class="col-12 pt-4">
          <button [disabled]="loading" class="btn tertiary rounded-pill submit" id="save"
                  type="button" (click)="saveAndExit()" (keyup.enter)="saveAndExit()">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.save-and-exit', 'Save and exit') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
